<template>
  <div id="SearchChat">
    <div
      class="panel panel-default"
      style="margin-bottom:unset"
      v-if="!$store.state.chat.isMobileMode"
    >
      <div class="panel-heading web-ui"></div>
      <div class="panel-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="uk-margin-small-bottom">
              <span class="tagAll" v-for="tag in listTagSearch" :key="tag">
                <el-tag
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                  >{{ tag }}</el-tag
                >
              </span>
            </div>
            <input
              type="text"
              @keyup.enter="enterSearch"
              @keyup.exact="chekSearch"
              v-model="search"
              class="search-ui"
              ref="txtSearch"
              placeholder="Search for customers"
              style="width: 85%"
              v-if="!searchTags"
            />
            <button
              class="el-button el-button--primary"
              @click="clearSearchWithActive"
              v-if="!searchTags"
              style="padding: 17px 16px; border-radius: 2px;font-size: 17px;"
              type="button"
            >
              All
            </button>
            <div class="tag-buttons">
              <button
                v-if="searchTags"
                v-for="tag in ['paid','nopaid']"
                :key="tag"
                :class="{'active': listTagSearch.includes(tag)}"
                @click="toggleTag(tag)"
              
              >
                {{ tag }}({{tag=='paid'?parseFloat($store.state.chat.paidCountAll).toLocaleString("en-US") : parseFloat($store.state.chat.unpaidCountAll).toLocaleString("en-US")}}) 
              </button>
            </div>
            <input
              v-if="searchTags"
              type="text"
              class="search-tag"
              v-model="inputTags"
              placeholder="Search for tags"
              @keyup.enter="handleInputConfirm"
              @blur="handleInputConfirm"
            />
            <div
              class="pa-sm"
              style="font-size: 18px;display:flex; justify-content: space-between; align-items: center;margin-bottom:unset;"
            >
              <div style="margin-right: 2px;" class="gutter-sm">
                <div class="row" style="margin-left: 4px;">
                  <label>ลูกค้า</label>                
                  <label>
                    <input
                      type="radio"
                      name="mycustomer"
                      v-model="customerSelf"
                      v-bind:value="true"
                      @click="handleSelectFilter"
                    />
                    Filter
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="mycustomer"
                      v-model="customerSelf"
                      v-bind:value="false"
                      @click="handleSelectFilter"
                    />
                    All
                  </label>
                  </div>
                  <div class="row" v-show="customerSelf" style="margin-left: 4px;">
                    <label>
                    <input
                      type="radio"
                      @click="handleSelectFilter"
                      name="customerTeam"
                      v-model="customerTeams"
                      value="-"
                    />
                    ของฉัน
                  </label>
                  <label>
                    <input
                      type="radio"
                      @click="handleSelectFilter"
                      name="customerTeam"
                      v-model="customerTeams"
                      value="a"
                    />
                    Team A
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="customerTeam"
                      @click="handleSelectFilter"
                      v-model="customerTeams"
                      value="b"
                    />
                    Team B
                  </label>
                  </div>
              </div>
              <div
                class="gutter-sm"
                style="display: flex; align-items: center; flex-wrap: wrap; width:125px"
              >
                <label>
                  <input
                    class="uk-radio"
                    type="radio"
                    name="Select01"
                    v-model="searchTags"
                    v-bind:value="true"
                  />
                  Tag
                </label>
                <label>
                  <input
                    class="uk-radio"
                    type="radio"
                    name="Select01"
                    v-model="searchTags"
                    v-bind:value="false"
                  />
                  All
                </label>
                <label>
                  <input
                    class="uk-checkbox"
                    type="checkbox"
                    v-model="notResponse"
                    @click="handleSelectFilter"
                  />
                  <span> รอตอบกลับ</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search-chat" v-if="$store.state.chat.isMobileMode">
      <div class="uk-margin-small-bottom">
              <span class="tagAll" v-for="tag in listTagSearch" :key="tag">
                <el-tag
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                  >{{ tag }}</el-tag
                >
              </span>
            </div>
      <input
        type="text"
        @keyup.enter="enterSearch"
        @keyup.exact="chekSearch"
        v-model="search"
        class="search-ui"
        ref="txtSearch"
        placeholder="Search for customers name..."
        style="width: 86%"
        v-if="!searchTags"
      />
      <button
        class="el-button el-button--primary"
        @click="clearSearchWithActive"
        v-if="!searchTags"
        style="padding: 17px 16px; border-radius: 2px;font-size: 17px;"
        type="button"
      >
        All
      </button>
      <div class="tag-buttons">
              <button
               v-if="searchTags"
                v-for="tag in ['paid','nopaid']"
                :key="tag"
                :class="{'active': listTagSearch.includes(tag)}"
                @click="toggleTag(tag)"
              
              >
               <!-- {{ tag }}-->({{tag=='paid'?parseFloat($store.state.chat.paidCountAll).toLocaleString("en-US") : parseFloat($store.state.chat.unpaidCountAll).toLocaleString("en-US")}}) 
              </button>
            </div>
            <input
              v-if="searchTags"
              type="text"
              class="search-tag"
              v-model="inputTags"
              placeholder="Search for tags"
              @keyup.enter="handleInputConfirm"
              @blur="handleInputConfirm"
            />
      <div style="margin: auto; font-size:22px; margin: 8px 0px;" class="gutter-sm">
        <div class="row" style="margin-left: 4px;">
                  <label>ลูกค้า</label>                
                  <label>
                    <input
                      type="radio"
                      name="mycustomer"
                      v-model="customerSelf"
                      v-bind:value="true"
                      @click="handleSelectFilter"
                    />
                    Filter
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="mycustomer"
                      v-model="customerSelf"
                      v-bind:value="false"
                      @click="handleSelectFilter"
                    />
                    All
                  </label>
                  </div>
                  <div class="row" v-show="customerSelf" style="margin-left: 4px;">
                    <label>
                    <input
                      type="radio"
                      @click="handleSelectFilter"
                      name="customerTeam"
                      v-model="customerTeams"
                      value="-"
                    />
                    ของฉัน
                  </label>
                  <label>
                    <input
                      type="radio"
                      @click="handleSelectFilter"
                      name="customerTeam"
                      v-model="customerTeams"
                      value="a"
                    />
                    Team A
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="customerTeam"
                      @click="handleSelectFilter"
                      v-model="customerTeams"
                      value="b"
                    />
                    Team B
                  </label>
                  </div>
      </div>
      <div
                class="gutter-sm"
                style="display: flex; align-items: center; flex-wrap: wrap; width:125px"
              >
                <label>
                  <input
                    class="uk-radio"
                    type="radio"
                    name="Select01"
                    v-model="searchTags"
                    v-bind:value="true"
                  />
                  Tag
                </label>
                <label>
                  <input
                    class="uk-radio"
                    type="radio"
                    name="Select01"
                    v-model="searchTags"
                    v-bind:value="false"
                  />
                  All
                </label>
                <label>
                  <input
                    class="uk-checkbox"
                    type="checkbox"
                    v-model="notResponse"
                    @click="handleSelectFilter"
                  />
                  <span> รอตอบกลับ</span>
                </label>
              </div>
    </div>

    <div id="contact-cus" v-if="searchCustomers.length > 0" style="position: relative;">
      <div class="header-group" v-show="search != ''">Contact Customer</div>
      <scroll-box
        class="customer-showScoll"
        id="listChat"
        @on-scroll-bottom="loadMoreCustomer"
        :bottom-offset="130"
        v-bind:style="{
          height: searchCustomers.length > 8 && searchCustomersMessage.length > 0 ? 'calc(77vh - 200px)' : search != '' ? 'calc(153vh - 244px)' : 'calc(153vh - 200px)',
          overflowY: searchCustomers.length > 8 ? 'scroll' : 'none',
        }"
      >
        <ul
          class="list-group"
          :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
        >
          <li
            v-for="item in searchCustomers"
            :key="item.custId"
            @click="$store.dispatch('chat/setActiveChatCustumer', item)"
            :class="{ active: isActive(item), 'has-failed-messages': item.hasFailedMessages }"
            class="list-group-item"
          >
            <div class="uk-grid-small uk-flex-middle" uk-grid>
              <div class="uk-width-auto">
                <div class="customer-profile">
                  <img
                    width="64"
                    height="64"
                    :src="
                      `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(
                        encodeURIComponent(item.custImage),
                      )}`
                    "
                    class="uk-border-circle"
                    data-src="holder.js/64x64"
                    style="width: 54px; height: 54px;"
                    data-holder-rendered="true"
                  />
                  <img
                    class="customer-source"
                    v-bind:src="
                      `/static/${
                        item.channelName == 'Line OA'
                          ? 'line_oa'
                          : item.customerSource || 'line'
                      }_icon_16.png`
                    "
                  />
                </div>
              </div>
              <div class="uk-width-expand">
                <div class="list-time" v-time="item.latestUpdated"></div>
                <span class="badge msg-unread" v-show="item.count != 0">
                  {{ item.count }}
                </span>
                <span
                  class="badge msg-failed"
                  v-show="item.hasFailedMessages"
                  :title="`${item.failedMessageCount} ข้อความส่งไม่สำเร็จ`"
                >
                  <i class="fas fa-exclamation-triangle"></i>
                  {{ item.failedMessageCount }}
                </span>
                <h4 class="uk-margin-remove-bottom uk-margin-remove-top">
                  {{
                    item.custNameNew == '' ? item.custName : item.custNameNew
                  }}
                  <el-tag v-if="item.hold" size="mini" type="warning" effect="dark" style="height: 22px; transform: translateY(-2px);">Hold</el-tag>
                </h4>
                <div
                  style="margin-bottom:10px"
                  :class="{
                    'box-arrow-left': item.sender == 'C',
                    'box-arrow-right': item.sender == 'R',
                    'bot-message':
                      item.isBot ||
                      (item.sender == 'R' && item.latestMsg.startsWith('/')),
                  }"
                >
                  <p class="last-message" v-lastmsg="item"></p>
                </div>
                <br />
                <div
                  class="uk-margin-medium-top"
                  v-if="item.tags && item.tags.length > 0"
                >
                  <span class="tagAll" v-for="tag in item.tags" :key="tag">
                    <el-tag size="mini">{{ tag }}</el-tag>
                  </span>
                </div>
              </div>
              <div class="uk-card-media-left uk-margin-auto-top">
                <div class="reservation-main">
                  <reservation-small
                    :profile="item.reservationMain || {}"
                  ></reservation-small>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </scroll-box>
      <div v-if="customersLoadMoreLoading" class="loading-more">
        <i class="fas fa-spinner fa-spin"></i>
        <span style="font-size: 18px">Loading more...</span>
      </div>
    </div>
    <div id="list-msgCus" v-if="searchCustomersMessage.length > 0">
      <div class="header-group" v-show="search != ''">Message</div>
      <ul
        class="list-group customer-showScoll"
        v-bind:style="{
          height:
            searchCustomersMessage.length > 8 && search == ''
              ?  search != '' ? 'calc(153vh - 244px)' : 'calc(153vh - 200px)'
              : 'calc(77vh - 200px)',
          overflowY: searchCustomersMessage.length > 8 ? 'scroll' : 'none',
        }"
      >
        <li
          v-for="item in searchCustomersMessage"
          :key="item.custId"
          @click="$store.dispatch('chat/setActiveChatCustumer', item)"
          class="list-group-item"
        >
          <div class="uk-grid-small uk-flex-middle" uk-grid>
            <div class="uk-width-auto">
              <img
                width="64"
                height="64"
                :src="
                  `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(
                    encodeURIComponent(item.custImage),
                  )}`
                "
                class="uk-border-circle"
                data-src="holder.js/64x64"
                style="width: 54px; height: 54px;"
                data-holder-rendered="true"
              />
            </div>
            <div class="uk-width-expand">
              <div class="list-time" v-time="item.latestUpdated"></div>
              <span class="badge msg-unread" v-show="item.count != 0">
                {{ item.count }}
              </span>
              <h4 class="uk-margin-remove-bottom uk-margin-remove-top">
                {{ item.custNameNew == '' ? item.custName : item.custNameNew }}
              </h4>
              <span>พบ {{ item.searchcount }} ข้อความ</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div
      id="list-msgCusNotFind"
      class="msg-error"
      v-if="
        loading == false &&
          searchCustomersMessage.length == 0 &&
          searchCustomers.length == 0
      "
    >
      <span>ไม่พบการค้นหา</span>
    </div>
    <div>
      <iframe id="grid1" width="100px" height="0px" :src="url"></iframe>
      <!-- ปรับ height 0px แก้ปัญหา scroll -->
    </div>
  </div>
</template>
<script>
import dateFormat from 'dateformat';
import { mapGetters } from 'vuex';
import { DialogStatus } from '../store';
import ScrollBox from './ScrollBox.vue';
import ReservationSmall from './ReservationSmall.vue';
import { sortBy } from 'lodash';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Tag } from 'element-ui';
import filter from 'lodash/filter';
export default {
  name: 'ListChat',
  data() {
    return {
      search: '',
      textSearch: '',
      listChatApp: [],
      listMsgApp: [],
      size: 100,
      dataCus: {},
      lastMessage: {},
      maxWidth: '',
      isClickSearch: false,
      onScroll: new Subject(),
      subscriptions: [],
      searchTags: true,
      notResponse: false,
      inputTags: '',
      listTagSearch: [],
      url:
        this.$store.state.chat.autoLoginUrl +
        '?token=' +
        window.sessionStorage.getItem('token'),
    };
  },
  components: {
    ScrollBox,
    ReservationSmall,
    [Tag.name]: Tag,
  },
  filters: {
    checkImage: function(value) {
      if (!value) return '';
      return value
        .replace('<img src=', '')
        .replace("class='ui-path-img-profile' />", '')
        .replace(/'/g, '');
    },
  },
  directives: {
    time: {
      bind: function(el, binding) {
        var nowDate = dateFormat(new Date(), 'dd mmm yy');
        var dateBinding = dateFormat(new Date(binding.value), 'dd mmm yy');
        var nowDateNumber = new Date().getDate();
        var dateTomorrow = dateFormat(
          new Date().setUTCDate(nowDateNumber - 1),
          'dd mmm yy',
        );
        var dateBindingTomorrow = dateFormat(
          new Date(binding.value),
          'dd mmm yy',
        );
        if (dateTomorrow == dateBindingTomorrow) {
          el.innerHTML = 'เมื่อวานนี้';
        } else if (nowDate == dateBinding) {
          el.innerHTML = dateFormat(new Date(binding.value), 'HH:MM น.');
        } else {
          el.innerHTML = dateFormat(
            new Date(binding.value),
            'dd mmm yy | HH:MM น.',
          );
        }
      },
      update(el, binding) {
        var nowDate = dateFormat(new Date(), 'dd mmm yy');
        var dateBinding = dateFormat(new Date(binding.value), 'dd mmm yy');
        var nowDateNumber = new Date().getDate();
        var dateTomorrow = dateFormat(
          new Date().setUTCDate(nowDateNumber - 1),
          'dd mmm yy',
        );
        var dateBindingTomorrow = dateFormat(
          new Date(binding.value),
          'dd mmm yy',
        );

        if (dateTomorrow == dateBindingTomorrow) {
          el.innerHTML = 'เมื่อวานนี้';
        } else if (nowDate == dateBinding) {
          el.innerHTML = dateFormat(new Date(binding.value), 'HH:MM น.');
        } else {
          el.innerHTML = dateFormat(
            new Date(binding.value),
            'dd mmm yy | HH:MM น.',
          );
        }
      },
    },
    lastmsg: {
      bind: function(el, binding) {
        var item = binding.value;
        if (item.latestMsg == null) {
          item.latestMsg = '';
        }
        if (item.type === 'flex') {
          el.innerText = item.latestMsg.altText + '\n(ข้อความอัตโนมัติ)';
        } else if (
          item.latestMsg.indexOf('stickershop') > 0 &&
          item.sender == 'C'
        ) {
          el.innerHTML = item.custName + 'ส่งสติ๊กเกอร์';
        } else if (item.type == 'image' && item.sender == 'R') {
          el.innerHTML = 'คุณส่งรูปภาพ';
        } else if (
          (item.latestMsg.indexOf('mushbot-static.softsq.com') > 0 ||
            item.latestMsg.indexOf('chatbot-files-s3.s3.amazonaws.com') > 0) &&
          item.sender == 'C'
        ) {
          if (item.latestMsg.match(/\.(pdf|docx?|xlsx?)$/)) {
            el.innerHTML = item.custName + 'ส่งไฟล์';
          } else {
            el.innerHTML = item.custName + 'ส่งรูปภาพ';
          }
        } else {
          if (item.latestMsg.length > 100) {
            el.innerText = item.latestMsg.substring(0, 100) + '...';
          } else {
            el.innerText = item.latestMsg;
          }
        }
      },
      update(el, binding) {
        var item = binding.value;
        if (item.latestMsg == null) {
          item.latestMsg = '';
        }

        if (typeof item.latestMsg === 'object') {
          el.innerText = item.latestMsg.altText + '\n(ข้อความอัตโนมัติ)';
        } else {
          if (item.latestMsg.indexOf('stickershop') > 0 && item.sender == 'C') {
            el.innerHTML = item.custName + 'ส่งสติ๊กเกอร์';
          } else if (item.type == 'image' && item.sender == 'R') {
            el.innerHTML = 'คุณส่งรูปภาพ';
          } else if (
            (item.latestMsg.indexOf('mushbot-static.softsq.com') > 0 ||
              item.latestMsg.indexOf('chatbot-files-s3.s3.amazonaws.com') >
                0) &&
            item.sender == 'C'
          ) {
            if (item && item.lastestMsg != undefined) {
              if (item.lastestMsg.match(/\.(pdf|docx?|xlsx?)$/)) {
                el.innerHTML = item.custName + 'ส่งไฟล์';
              } else {
                el.innerHTML = item.custName + 'ส่งรูปภาพ';
              }
            }
          } else {
            if (item.latestMsg.length > 100) {
              el.innerText = item.latestMsg.substring(0, 100) + '...';
            } else {
              el.innerText = item.latestMsg;
            }
          }
        }
      },
    },
  },
  watch: {
    dialogStatus: {
      immediate: true,
      handler(status) {
        if (status == DialogStatus.MOVE) {
          this.$store.dispatch('chat/setActiveChatCustumer', null);
          this.$store.dispatch('contact/setActiveContactCustumer', null);
        }
      },
    },
    searchTags: {
      immediate: true,
      handler(value) {
        //console.log('searchTags x', value);
        if (!value) {
          if (!this.typeOpenChat) {
            this.listTagSearch = [];
            this.clearSearchWithActive();
          }
        } else {
          this.$store.dispatch('chat/setTypeChat', false);
          this.listTagSearch = [];
          this.clearSearchWithActive();
        }      
      },
    },
    notResponse: {
      immediate: true,
      handler(value) {
        this.$store.commit('chat/searchNotResponse', value);
        this.clearSearchWithActive();
        console.log('notResponse : ', value);
        this.$store.dispatch('chat/loadCountTagPaidAndUnpaid')
      },
    },
    '$store.state.chat.customerSelf': async function(newValue) {
      console.log('customerself', newValue);
      await this.$store.dispatch('chat/loadCustomers');
      this.$store.commit('chat/loading', false);
    },
    '$store.state.chat.customerTeams': async function(newValue) {
      console.log('customerTeams', newValue);
      await this.$store.dispatch('chat/loadCustomers');
      this.$store.dispatch('chat/loadCountTagPaidAndUnpaid')
      this.$store.commit('chat/loading', false);
    },
  },
  computed: {
    CheckCus: function() {
      return this.customers.length > 10;
    },
    CheckMsg: function() {
      return this.customers.length > 10;
    },
    isActive: function() {
      return item => {
        return (
          this.activeChatCustomer &&
          this.activeChatCustomer.custId == item.custId
        );
      };
    },
    customerSelf: {     
      get: function() {
        return this.$store.state.chat.customerSelf;
      },
      set: function(newValue) {
        this.$store.commit('chat/customerSelf', newValue);
      },
    },
    customerTeams: {
      get: function() {        
        console.log('computed customerTeams get : ', this.$store.state.chat.customerTeams);
        return this.$store.state.chat.customerTeams
      },
      set: function(newValue) {
        console.log('computed customerTeams set: ', newValue);
        this.$store.commit('chat/customerTeams', newValue);
        
      },
    },
    searchCustomers: function() {
      let customers = [...this.customers];
      // console.log(this.customers,'customers');
      // console.log(this.customerTeams,'state.customerTeams');
      // console.log(this.customerSelf,'state.customerSelf');
      // console.log(this.$store.state.reservationId,'state.reservationId');
      const resTeam = {
                        "a": "7445,15502,15668,14158,15582,7408,15132,16021,16111",
                        "b": "12257,15810,15518,14175,14600,15667,15793,15792,14510,14600,16098,16110,16148"
                 };
      //console.log('resTeam : ',  resTeam);
      console.log('--- ListChat ---');
      //==============  FOR GET FROM API n8n =================
      //const resTeam = this.$store.state.chat.reservationteam
      //console.log('resTeam : ', JSON.stringify(resTeam));
      //==============  END FOR GET API n8n =================
      console.log('this.customerTeams : ', this.customerTeams == '');
      if(this.customerSelf){
        if(this.customerTeams == '-' || this.customerTeams == ''){
          customers = customers.filter(c => c.reservationMain.reservationId == this.$store.state.reservationId);
        }else{
          //console.log('Check',resTeam[this.customerTeams], this.$store.state.reservationId);
          customers = customers.filter(c =>  resTeam[this.customerTeams].indexOf(c.reservationMain.reservationId) > -1) ;
        }
        
      }
      const newCustomer = sortBy(
        customers.filter(c => c.firstMessageRead === false ),
        c => new Date(c.firstMessageTime),
      );
      const oldCustomerUnread = sortBy(
        customers.filter(c => c.firstMessageRead === true && c.count !== 0),
        c => new Date(c.latestUpdated) * -1,
      );
      const oldCustomerRead = sortBy(
        customers.filter(c => c.firstMessageRead === true && c.count === 0),
        c => new Date(c.latestUpdated) * -1,
      );
      return newCustomer.concat(oldCustomerUnread).concat(oldCustomerRead);
    },
    ...mapGetters('chat', [
      'loading',
      'customers',
      'activeChatCustomer',
      'searchCustomersMessage',
      'searchContactCustomer',
      'customersLoadMoreLoading',
      'customersLoading',
      'typeOpenChat',
    ]),
    ...mapGetters(['dialogStatus', 'cusIdActive']),
  },
  methods: {
    toggleTag(tag) {
      console.debug('tag',tag);
      if( tag == 'paid'){
        this.listTagSearch = this.listTagSearch.filter(t => t !== 'nopaid');
        this.listTagSearch = this.listTagSearch.filter(t => t !== 'paid');
        this.listTagSearch.push('paid');
      }else{
        this.listTagSearch = this.listTagSearch.filter(t => t !== 'paid');
        this.listTagSearch = this.listTagSearch.filter(t => t !== 'nopaid');
        this.listTagSearch.push('nopaid');
      }
      this.$store.dispatch('chat/loadCusForTags', this.listTagSearch);
      // if (this.listTagSearch.includes(tag)) {
      //   this.listTagSearch = this.listTagSearch.filter(t => t !== tag);
      //   this.listTagSearch.push(tag == 'paid' ? 'nopaid' : 'paid');
      // } else {
      //   this.listTagSearch.push(tag);
      // }
    },
    handleSelectFilter() {
      console.log('handleSelectFilter', this.customerSelf, this.customerTeams);
      if(this.listTagSearch.length > 0){
        this.$store.dispatch('chat/loadCusForTags', this.listTagSearch)
      } 
     // this.$store.dispatch('chat/loadCountTagPaidAndUnpaid',this.$store.state.chat.customerTeams);
    },
    handleClose(tag) {
      //console.log('handleClose tag', tag);
      this.listTagSearch.splice(this.listTagSearch.indexOf(tag), 1);
      this.$store.dispatch('chat/loadCusForTags', this.listTagSearch);
    },
    handleInputConfirm() {
      let inputTags = this.inputTags;
      if (inputTags) {
        let input = inputTags.replace(/\s/g, '');
        var sameTagSearch = filter(this.listTagSearch, function(v) {
          return v == inputTags;
        });
        if (sameTagSearch && sameTagSearch.length > 0) return false;
        if (!input) return false;
        this.listTagSearch.push(inputTags);
        //console.log('handleInputConfirm', this.listTagSearch);
        this.$store.dispatch('chat/loadCusForTags', this.listTagSearch);
      }
      this.inputTags = '';
    },
    enterSearch: function({ target }) {
      this.search = target.value;
      if (this.search != '') {
        this.$store.dispatch('chat/searchMessage', this.search);
        this.$store.dispatch('chat/searchContact', this.search);
      } else {
        this.$store.dispatch('chat/clearSearchMessage');
        this.$store.dispatch('chat/clearSearchContact');
      }
    },
    chekSearch(e) {
      if (!e.target.value) {
        this.search = '';
        this.$store.dispatch('chat/clearSearchMessage');
        this.$store.dispatch('chat/clearSearchContact');
        this.$store.dispatch('chat/loadCustomers');
      }
    },
    clearSearchWithActive() {
      this.search = '';
      this.$store.dispatch('chat/clearSearchMessage');
      this.$store.dispatch('chat/clearSearchContact');
      this.$store.dispatch('chat/loadCustomers');
      this.$store.dispatch('chat/setActiveChatCustumer', null);
    },
    loadMoreCustomer() {
      this.onScroll.next(this.$store.state.chat.lastCustomer._id);
    },
  },
  async mounted() {
    console.log('--- mounted ListChat ---');
    this.$store.commit('chat/loading', true);
    
    if (this.dialogStatus == DialogStatus.CLOSE) {
      this.$destroy();
      return false;
    }
    setInterval(() =>this.$store.dispatch('chat/loadCountTagPaidAndUnpaid'), 120000);
    this.$store.dispatch('chat/connect').then(() => {
      console.log('--- this.cusIdActive --- : ', this.cusIdActive);
      console.log('--- this.customers.length --- : ', !this.customers.length);
      console.log('--- this.$route.query.custid --- : ', this.$route.query.custid);
      this.$store.dispatch('chat/setActiveChatCustumer', null);
     
      if (this.$route.query.custid != undefined) {
         console.log('--- this.$route.query.custid --- : ', this.$route.query.custid != undefined);
        this.$store.dispatch('chat/searchContactFromBooking',
        this.$route.query.custid,).then(async () => {
          console.log('FINISH loadCustomers');
             // if (this.cusIdActive && this.cusIdActive.length > 1) {
              this.$store.dispatch('setCusId', null);
                console.log('----- searchContactFromBooking- : ');
                //this.search = this.$route.query.custid;
                this.$store.dispatch(
                  'chat/loadCustomers'
                );
                console.log('End searchContactFromBooking');
           //   }

              if (this.$store.state.chat.pushNextCustomerOnLoad == true) {
                try {
                  await this.$store.dispatch('chat/pushNextCustomerToChatList');
                } catch (ex) {
                  console.log('error auto load next customer', ex);
                }
                this.$store.commit('chat/pushNextCustomerOnLoad', false);
              }
           
            });
      } else {
        //OLD Slow
          if (!this.customers.length) {
            this.$store.dispatch('chat/loadCustomers').then(async () => {
              console.log('--- OLD Slow --- : ', !this.customers.length);
              console.log('--- this.cusIdActive --- : ', this.cusIdActive);
             // console.log('--- cusIdActive.length > 1 --- : ', this.cusIdActive.length > 1);
              if (this.cusIdActive && this.cusIdActive.length > 1) {
                console.log('--- searchContactForActive--- : ');
                this.search = this.cusIdActive;
                this.$store.dispatch(
                  'chat/searchContactForActive',
                  this.cusIdActive,
                );
                console.log('End searchContactForActive');
              }

              if (this.$store.state.chat.pushNextCustomerOnLoad == true) {
                try {
                  await this.$store.dispatch('chat/pushNextCustomerToChatList');
                } catch (ex) {
                  console.log('error auto load next customer', ex);
                }
                this.$store.commit('chat/pushNextCustomerOnLoad', false);
              }
              // if (this.$route.query.custid != undefined){
              //   //this.$store.dispatch('.state.chat.
              // // state.lastCustomer
              // console.log(this.$store.state.chat.customers)
              // let dtCustomers = this.$store.state.chat.customers;
              // var item=dtCustomers.filter(obj=> obj.custId == this.$route.query.custid);
              // console.log('result : ', item[0].custId)
              // this.$store.dispatch('chat/setActiveChatCustumer', item[0])
              // }
            });
          // } else {
          //   console.log('created : ', this.$route.query.custid);
          //   if (this.$route.query.custid != undefined) {
          //     //this.$store.dispatch('.state.chat.
          //     // state.lastCustomer
          //     console.log(this.$store.state.chat.customers);
          //     let dtCustomers = this.$store.state.chat.customers;
          //     var item = dtCustomers.filter(
          //       obj => obj.custId == this.$route.query.custid,
          //     );
          //     console.log('result : ', item[0].custId);
          //     this.$store.dispatch('chat/setActiveChatCustumer', item[0]);
          //   }
          }
      }    
      
      this.$store.dispatch('contact/setActiveContactCustumer', null);
     // this.listTagSearch = [];
      const subscribeScroll = this.onScroll
        .pipe(distinctUntilChanged())
        .subscribe({
          next: () => {
           // console.log('subscribeScroll', this.listTagSearch);
           // console.log('searchTags', this.searchTags);
            if (!this.searchTags) {
              this.listTagSearch = [];
              this.$store.dispatch('chat/loadMoreCustomer', this.search);
            } else {
              this.$store.dispatch(
                'chat/loadMoreCustomerForTags',
                this.listTagSearch,
              );
            }
          },
        });

      this.subscriptions.push(subscribeScroll);
    });
  },
  beforeDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  },
};
</script>
<style scoped>
@media (max-width: 767px) {
  #SearchChat {
    border-right: 1px solid #ddd;
  }
}
#SearchChat .panel {
  border-radius: unset;
  -webkit-box-shadow: unset;
  box-shadow: unset;
  border: unset;
}
.list-group-item {
  border-right: unset;
}
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #00978b;
  border-color: #00978b;
}
.list-group-item.active span.el-tag,
.list-group-item.active:hover span.el-tag,
.list-group-item.active:focus span.el-tag {
  color: #fff !important;
  border: 1px solid #ffff !important;
}
.list-group-item:last-child {
  border-bottom-right-radius: unset;
  border-bottom-left-radius: unset;
}
.list-group-item:first-child {
  border-bottom-right-radius: unset;
  border-bottom-left-radius: unset;
}

#SearchChat ul.list-group .media-body span {
  font-size: 1.48em;
}

.customer-showScoll::-webkit-scrollbar-track {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.customer-showScoll::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

.customer-showScoll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #00978b;
}
.customer-profile {
  position: relative;
}
.customer-source {
  display: block;
  position: absolute;
  left: -4px;
  bottom: -2px;
  border-radius: 4px;
}
.header-group {
  font-size: 18px;
  color: #fff;
  background: #00978b;
  padding: 10px 0px 10px 15px;
  font-weight: bold;
}
.msg-error {
  text-align: center;
  font-size: 16px;
  color: red;
}

.box-arrow-right {
  list-style: none;
  position: relative;
  background: #e4e7ed;
  border-radius: 4px;
  line-height: 22px;
  padding: 5px;
  margin-right: 12px;
  float: right;
  display: inline-block;
  max-width: 295px;
}
.box-arrow-right.bot-message {
  background-color: #fca276;
}
.box-arrow-right:after,
.box-arrow-right:before {
  left: 100%;
  top: 25%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.box-arrow-right:after {
  border-color: rgba(136, 183, 213, 0);
  border-left-color: #e4e7ed;
  border-width: 8px;
}
.box-arrow-right.bot-message:after {
  border-left-color: #fca276;
}
.box-arrow-right > p.last-message {
  margin: 0;
  color: #303133;
  overflow: hidden;
}
.box-arrow-left {
  list-style: none;
  position: relative;
  background: #03afa16e;
  border-radius: 4px;
  line-height: 22px;
  padding: 5px;
  margin-left: 12px;
  float: left;
  display: inline-block;
  max-width: 295px;
}
.box-arrow-left:after,
.box-arrow-left:before {
  right: 100%;
  top: 60%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.box-arrow-left:after {
  border-color: rgba(136, 183, 213, 0);
  border-right-color: #03afa16e;
  border-width: 8px;
  margin-top: -12px;
}
p.last-message {
  margin: 0;
  word-break: break-all;
}
.reservation-main {
  vertical-align: bottom;
}
.msg-unread {
  margin: 36px 0px 0px -30px;
  float: none;
  position: absolute;
  background: #00978b !important;
}
.msg-failed {
  margin: 36px 0px 0px -60px;
  float: none;
  position: absolute;
  background: #dc3545 !important;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
}
.msg-failed i {
  margin-right: 3px;
  font-size: 10px;
}
.list-group-item.has-failed-messages {
  border-left: 3px solid #dc3545;
}
.tagAll {
  margin: 0px 7px 7px 0px !important;
  display: inline-block;
}
@media (max-width: 767px) {
  input[type='text'].search-ui {
    width: 86% !important;
  }
  input[type='text'].search-tag {
    width: 100% !important;
  }
}

.loading-more {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 15px 10px;
  color: #00978b;
  font-size: 14px;
  background-color: rgba(245, 245, 245, 0.95);
  border-top: 1px solid #ddd;
  z-index: 10;
}

.loading-more i {
  margin-right: 8px;
  font-size: 16px;
}

.loading-more span {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/ListChat.vue